import apiClient from "@/app/api/client";
import type { TaskCreateInput, TaskDetail, TaskUpdateInput } from "../types";

interface SingleTaskResponse {
	success: true;
	data: TaskDetail;
}

export const tasksService = {
	async detail(id: string): Promise<TaskDetail> {
		const response = await apiClient.get<SingleTaskResponse>(`/tasks/${id}`);
		return response.data.data;
	},

	async create(input: TaskCreateInput): Promise<TaskDetail> {
		const response = await apiClient.post<SingleTaskResponse>("/tasks", input);
		return response.data.data;
	},

	async update(id: string, input: TaskUpdateInput): Promise<TaskDetail> {
		const response = await apiClient.patch<SingleTaskResponse>(`/tasks/${id}`, input);
		return response.data.data;
	},

	/**
	 * ⚠️ Bekor qilish — `POST /tasks/{id}/cancel`, `DELETE` EMAS.
	 * Ular ikki BOSHQA amal: `cancel` topshiriqni `bekor_qilingan`
	 * holatiga o'tkazadi va biriktirishlarni yopadi (tarix qoladi),
	 * `DELETE` esa `is_deleted` soft delete.
	 */
	async cancel(id: string): Promise<TaskDetail> {
		const response = await apiClient.post<SingleTaskResponse>(`/tasks/${id}/cancel`);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/tasks/${id}`);
	},
};
